module.exports = __webpack_public_path__ + "img/time.f1f09a04.svg";